import { useState } from "react";
import PropTypes from "prop-types";

import { t } from "../../services";

import { Paragraph2 } from "../Text/Paragraphs";
import { TextButton } from "./styled";

const IconTextButton = ({ children, icon, hoverIcon, onClick = () => {}, disabled = false }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <TextButton
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      {hoverIcon && isHovered ? hoverIcon : icon}
      <Paragraph2>{t(children)}</Paragraph2>
    </TextButton>
  );
};

IconTextButton.propTypes = {
  children: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  hoverIcon: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default IconTextButton;
